var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.canEdit || _vm.canDelete)?_c('div',{staticClass:"view work-type-details"},[_c('agro-editor',{attrs:{"config":_vm.config,"name":_vm.$t('common.work_type')}})],1):_c('div',[_c('forbidden')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }